// extracted by mini-css-extract-plugin
export default {"mainContainer":"civ-card_mainContainer__uim+U","card":"civ-card_card__7d9rP","body":"civ-card_body__s65Ll"};